import { withPermission } from "app/auth/components/withPermission";
import { Settings } from "../screens/Settings";
import MyDevicesComponent from "../screens/MyDevices";
import NoAccessScreen from "@shared/components/NoAccessScreen";
import { Faq } from "../screens/Faq";
import DummyScreen from "app/_modules/core/screens/DummyScreen";
import MyPathwayComponent from "../screens/MyPathway";
import TeleassistanceRequestComponent from "../screens/TeleassistanceRequestScreen";

export const SettingsScreen = withPermission(
  Settings,
  'noRestrictions::all',
  { Fallback: NoAccessScreen }
);

export const FaqScreen = withPermission(
  Faq,
  'noRestrictions::all',
  { Fallback: NoAccessScreen }
);
export const TestScreen = withPermission(
  DummyScreen,
  'noRestrictions::all',
  { Fallback: NoAccessScreen }
);

export const MyPathwayScreen = withPermission(
  MyPathwayComponent,
  'noRestrictions::all',
  { Fallback: NoAccessScreen }
);

export const TeleassistanceRequestScreen = withPermission(
  TeleassistanceRequestComponent,
  'noRestrictions::all',
  { Fallback: NoAccessScreen }
);

export const MyDevicesScreen = withPermission(
  MyDevicesComponent,
  'noRestrictions::all',
  { Fallback: NoAccessScreen }
);